import styled from "styled-components/macro";

import { baseButtonStyles } from "../../styles/sharedStyles";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
    
  @media (max-width: 1439px) {
    gap: 12px;
  }

  @media (max-width: 979px) {
    flex-direction: column-reverse;
  }
`

export const ImgBlock = styled.div<{bgImage: string}>`
  background-image: ${({ bgImage }) => bgImage ? `url(${bgImage})` : "none"};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 50%;
  height: auto;
  border-radius: 24px;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @media (max-width: 979px) {
    width: 100%;
    height: 400px;
    // test
    padding: 0 12px;
  }
`

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  background-color: transparent;
  width: 50%;

  @media (max-width: 1439px) {
    gap: 12px;
  }

  @media (max-width: 979px) {
    width: 100%;
    align-items: baseline;
  }
`

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 14px;
  padding: 26px;
  border-radius: 24px;
  background-color: #fff;

  @media (max-width: 979px) {
    width: 100%;
    align-items: center;
  }
`

export const Title = styled.span`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 35px;
  line-height: 86%;
  font-weight: 600;

  @media (max-width: 979px) {
    font-size: 30px;
    text-align: center;
  }
`

export const Text = styled.span`
  font-size: 18px;
  line-height: 140%;

  @media (max-width: 979px) {
    font-size: 15px;
    text-align: center;
  }
`

export const Button = styled.button`
  ${baseButtonStyles};
  box-sizing: border-box;
  margin-bottom: 30px;
`
